<div class="content">
    <section>
      <h2>TERMINE</h2>
      <p>Wir freuen uns auch in diesem Jahr wieder auf viele spannende Verantaltungen. Schaue regelmäßig vorbei um nichts zu verpassen. Wir freuen uns darauf, Dich bei einem unserer nächsten Events begrüßen zu dürfen.</p>
      <app-events-builder></app-events-builder>
    </section>
  </div>
  